import { Left } from './Left'
import { RightAdd } from './RightAdd'
import { RightEdit } from './RightEdit'
import { useApprovalModel } from "../approvalModel";
import '../approval.less'

export const BaseApproval = () => {

    const { selectedShop, selectType, setSelectType } = useApprovalModel()

    return (
        <>
            <div className="container">
                <div className="child left">
                    <Left />
                </div>
                {/* <div className="child middle">
                    <Middle />
                </div> */}
                <div className="child right">
                    {selectType && selectType == 'add' && <RightAdd />}
                    {selectType && selectType == 'edit' && <RightEdit />}
                </div>
            </div >
        </>
    )
}